import { useMutation } from '@tanstack/react-query';
import remoteSubmissionApi from './remoteSubmissionApi';
export const useCreateRemoteSubmission = () => useMutation({
    mutationFn: ({ token, data, }) => {
        const formData = new FormData();
        if (data.description) {
            formData.append('description', data.description);
        }
        data.elements.forEach((element) => {
            formData.append('elements[]', element.toString());
        });
        if (data.location_type_id) {
            formData.append('location_type_id', data.location_type_id.toString());
        }
        if (data.location_id) {
            formData.append('location_id', data.location_id.toString());
        }
        if (data.location_name) {
            formData.append('location_name', data.location_name);
        }
        data.media.forEach((file) => {
            formData.append('media[]', file);
        });
        return remoteSubmissionApi.create(token, formData);
    },
});
